import { ComponentProps } from 'react';

import { SimpleGrid } from 'ui';
import { IconMembershipCard, IconSheet, IconTicket } from 'ui/Icons';

import { Shortcut } from '../../../home/Shortcuts/Shortcuts';

type AccountShortcutProps = ComponentProps<typeof Shortcut>;

const AccountShortcut = (props: AccountShortcutProps) => {
  return (
    <Shortcut
      {...props}
      variant="gray"
      ActionIconProps={{
        w: '100%',
        h: '107px',
      }}
    />
  );
};

const AccountPageShortcuts = () => {
  return (
    <SimpleGrid cols={3} verticalSpacing="sm">
      <AccountShortcut
        label="Purchases"
        to="purchases"
        icon={(props) => <IconSheet {...props} />}
      />
      <AccountShortcut label="Tickets" to="events" icon={(props) => <IconTicket {...props} />} />
      <AccountShortcut
        label="Memberships"
        to="memberships"
        icon={(props) => <IconMembershipCard {...props} />}
      />
    </SimpleGrid>
  );
};

export { AccountPageShortcuts };
